import React from "react";
import type { FC } from "react";

import cn from "classnames";

import { slotFactory } from "../../utils/slotFactory";
import {
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_BOTTOM_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_LEFT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_LEFT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_MIDDLE_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_MIDDLE_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_RIGHT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_RIGHT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_TOP_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_DISPLAY_NAME,
    UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_TEST_ID,
    UNIBOX_ADDITIONAL_SLOT_TOP_TEST_ID,
} from "../../vars";

import type { UniBoxAdditionalSlotBaseProps } from "./types";

import classes from "./UniBoxAdditionalSlot.styl";

export const UniBoxAdditionalBaseSlot: FC<UniBoxAdditionalSlotBaseProps> = ({
    "data-tsid": tsid,
    children,
    customVarsStyles,
    className,
    zIndex,
    ...props
}) => {
    const uniBoxAdditionalClassnames = cn(
        className,
        classes["uniBox-additional-slot"],
        customVarsStyles,
    );

    const slotStyles = {
        zIndex:
            typeof zIndex === "number" && !Number.isNaN(zIndex)
                ? String(zIndex)
                : "auto",
    };

    return (
        <div
            {...props}
            style={slotStyles}
            className={uniBoxAdditionalClassnames}
            data-tsid={tsid || UNIBOX_ADDITIONAL_SLOT_TEST_ID}
        >
            {children}
        </div>
    );
};

export const UniBoxAdditionalSlotBottom = slotFactory({
    slotType: "bottom",
    displayName: UNIBOX_ADDITIONAL_SLOT_BOTTOM_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_BOTTOM_TEST_ID,
});

export const UniBoxAdditionalSlotBottomLeft = slotFactory({
    slotType: "bottom-left",
    displayName: UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_TEST_ID,
});

export const UniBoxAdditionalSlotBottomRight = slotFactory({
    slotType: "bottom-right",
    displayName: UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_TEST_ID,
});

export const UniBoxAdditionalSlotLeft = slotFactory({
    slotType: "left",
    displayName: UNIBOX_ADDITIONAL_SLOT_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_LEFT_TEST_ID,
});

export const UniBoxAdditionalSlotMiddle = slotFactory({
    slotType: "middle",
    displayName: UNIBOX_ADDITIONAL_SLOT_MIDDLE_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_MIDDLE_TEST_ID,
});

export const UniBoxAdditionalSlotRight = slotFactory({
    slotType: "right",
    displayName: UNIBOX_ADDITIONAL_SLOT_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_RIGHT_TEST_ID,
});

export const UniBoxAdditionalSlotTop = slotFactory({
    slotType: "top",
    displayName: UNIBOX_ADDITIONAL_SLOT_TOP_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_TOP_TEST_ID,
});

export const UniBoxAdditionalSlotTopLeft = slotFactory({
    slotType: "top-left",
    displayName: UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_TEST_ID,
});

export const UniBoxAdditionalSlotTopRight = slotFactory({
    slotType: "top-right",
    displayName: UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_DISPLAY_NAME,
    defaultTsid: UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_TEST_ID,
});
